import template from './booking-manager-list.html';
import controller from './booking-manager-list.controller';
import './booking-manager-list.styl';

const bookingManagerListComponent = {
  template,
  controller,
  controllerAs: 'bookingManagerList',
  require: {
    app: '^^app'
  }
};

export default bookingManagerListComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/booking/booking-manager-list/booking-manager-list.component.js
 **/